// src/pages/Reports/UserReport.jsx
import React from 'react';
import BusinessReport from './BusinessReport';

const UserReport = () => {
  return <BusinessReport userType="user" />;
};

export default UserReport;